import { Firestore } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';
import { JobApplication } from '@models';

import { BaseService } from '../base/base.service';

import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class JobApplicationService extends BaseService<JobApplication> {
  protected readonly documentPath = '/jobApplications';

  constructor(
    protected db: Firestore,
    protected toastService: ToastService
  ) {
    super(db, toastService);
  }
}
